import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLock,
  faCheckToSlot,
  faClipboardList,
  faBuildingMemo,
  faListDropdown,
  faBookCircleArrowUp,
  faGavel,
  faScroll,
  faAddressCard,
} from "@fortawesome/pro-duotone-svg-icons";

export const getPolicyIcons = () => [
  { label: <FontAwesomeIcon icon={faLock} />, value: "lock" },
  { label: <FontAwesomeIcon icon={faClipboardList} />, value: "clipboard" },
  { label: <FontAwesomeIcon icon={faCheckToSlot} />, value: "check-to-slot" },
  {
    label: <FontAwesomeIcon icon={faBuildingMemo} />,
    value: "building-memo",
  },
  {
    label: <FontAwesomeIcon icon={faListDropdown} />,
    value: "list-dropdown",
  },
  {
    label: <FontAwesomeIcon icon={faBookCircleArrowUp} />,
    value: "book-circle-arrow-up",
  },
  { label: <FontAwesomeIcon icon={faGavel} />, value: "gavel" },
  { label: <FontAwesomeIcon icon={faScroll} />, value: "scroll" },
  { label: <FontAwesomeIcon icon={faAddressCard} />, value: "address-card" },
];
